import { render } from "./DataView.vue?vue&type=template&id=dfb5b17e"
import script from "./DataView.vue?vue&type=script&lang=js"
export * from "./DataView.vue?vue&type=script&lang=js"

import "./DataView.vue?vue&type=style&index=0&id=dfb5b17e&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__